export default "__VITE_ASSET__CBlpsBhV__"